import styled from "react-emotion";
import { themeGet } from "styled-system";

export const Container = styled("div")`
  width: 100%;
  height: 100%;
  background: ${themeGet("colors.greyLighter")};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfirmationHeading = styled("h3")`
  color: ${themeGet("colors.blueDarker")};
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 700;
  text-decoration: underline;
`;

export const Wrapper = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 75%;
  background-color: #fff;
  padding: ${themeGet("space.5")}px ${themeGet("space.5")}px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  flex: 0 0 50vw;

  span {
    font-weight: 300;
    font-size: 18px;
    color: ${themeGet("colors.black")};
    padding: 0 ${themeGet("space.5")}px;
    text-align: center;
  }
`;

export const ConfirmationHeader = styled("div")`
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${themeGet("colors.greenLightest")};
  height: 200px;
  width: 200px;
`;



// WEBPACK FOOTER //
// ../shop_main/components/order/style.js